import { render } from "./BaseBlock.vue?vue&type=template&id=5f0c2aa7&ts=true"
import script from "./BaseBlock.vue?vue&type=script&lang=ts"
export * from "./BaseBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__